import * as Yup from "yup";

// Validation schemas of the auction edition form, kept in their own module so
// they can be exercised directly: importing AuctionEdition pulls the whole
// editor stack (draft-js, react-draft-wysiwyg), which is not worth booting to
// assert a Yup rule.

/**
 * Catalogue tab. Neither link is required: the API stores both as null
 * (InputAuctionManagementSerializer) and the public site renders "sem catálogo"
 * for an empty pair, so an edition without a catalogue must still be
 * publishable (spec 10, C9).
 *
 * @param {(key: string, vars?: object) => string} t translation function
 */
export const getCatalogueValidationSchema = (t) =>
  Yup.object({
    catalogue: Yup.array().of(
      Yup.object().shape({
        issuu_link: Yup.string(),
        pdf_catalogue: Yup.string(),
        pdf_erratum: Yup.string(),
      })
    ),
  });

/**
 * Information tab — unchanged by C9: publishing still needs its text.
 *
 * @param {(key: string, vars?: object) => string} t translation function
 */
export const getInfoValidationSchema = (t) =>
  Yup.object({
    auction_text: Yup.object().required(
      t("validation.generalField", {
        promptType: t("common.enter"),
        fieldType: t("common.auctionText"),
      })
    ),
    information_title: Yup.string(),
    information: Yup.object().required(
      t("validation.generalField", {
        promptType: t("common.enter"),
        fieldType: t("common.information"),
      })
    ),
    virtual_link: Yup.string(),
  });
